import { getActiveDevPreview } from "../../utils/devPreview";

// Small fixed-position banner that surfaces the active dev preview.
// Renders nothing in production (gated by getActiveDevPreview).
export default function DevPreviewBadge() {
  const name = getActiveDevPreview();
  if (!name) return null;
  return (
    <div
      data-testid="dev-preview-badge"
      style={{
        position: "fixed",
        top: 8,
        right: 8,
        zIndex: 9999,
        background: "#ff6b00",
        color: "#fff",
        padding: "4px 10px",
        borderRadius: 4,
        fontSize: 12,
        fontFamily: "monospace",
        fontWeight: 600,
        letterSpacing: 0.5,
        pointerEvents: "none",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      }}
    >
      DEV PREVIEW: {name}
    </div>
  );
}
